import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './contexts/AuthContext';
import App from './App';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';

// Initialize Sentry for error monitoring
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      new Integrations.BrowserTracing(),
    ],
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    environment: process.env.NODE_ENV,
    beforeSend(event) {
      // Don't send error reports in development
      if (process.env.NODE_ENV === 'development') {
        console.error('Sentry Event (dev only):', event);
        return null;
      }
      return event;
    },
  });
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick={true}
          rtl={false}
          pauseOnFocusLoss={false}
          draggable={true}
          pauseOnHover={true}
          theme="light"
          toastClassName=""
          bodyClassName=""
          progressClassName=""
          toastStyle={{}}
          limit={3}
          preventDuplicates={true}
        />
      </AuthProvider>
    </BrowserRouter>
  </HelmetProvider>
);